import React, { useState } from 'react'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import ServerInfo from '../../../pages/Server/ServerInfo'
import DataManagementMenu from './DataManagementMenu/DataManagementMenu'
import { getServerDownload } from '../../../services/endpoints'

const ServerMenu = (props: any) => {
  const [visible, setVisible] = useState(false)

  const handleServerInfo = () => {
    setVisible(!visible)
  }

  const handleDownload = () => {
    getServerDownload()
      .then((res) => {
        const replacer = (key, value) =>
          value instanceof Object && !(value instanceof Array)
            ? Object.keys(value)
                .sort()
                .reduce((sorted, key) => {
                  sorted[key] = value[key]
                  return sorted
                }, {})
            : value
        const newHref =
          'data:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(res, replacer, 2))
        return newHref
      })
      .then((newHref) => {
        const a = document.createElement('a')
        a.href = newHref
        a.download = `ServerInfo${newDate()}.json`
        a.click()
        a.remove()
      })
  }

  const newDate = () => {
    const date = new Date()
    return Date.parse(date.toDateString())
  }

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret className="glyphicons glyphicons-server">
        <p className="nav-link-p">{props.label}</p>
      </DropdownToggle>
      <DropdownMenu className="submenu">
        <DropdownItem>
          <a href="/ui/#!/server" className="glyphicons glyphicons-binoculars">
            Overview
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/server/announcements"
            className="glyphicons glyphicons-bullhorn"
          >
            Announcements
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/server/auditLogs"
            className="glyphicons glyphicons-auction"
          >
            Audit Logs
          </a>
        </DropdownItem>
        <DropdownItem toggle={false} id="data_mgmt_item">
          <DataManagementMenu />
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/server/licenses"
            className="glyphicons glyphicons-keys"
          >
            Licenses
          </a>
        </DropdownItem>
        <DropdownItem>
          {' '}
          <a href="/ui/#!/server/logs" className="glyphicons glyphicons-blog">
            Logs
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/server/jobQueue"
            className="glyphicons glyphicons-file-cloud"
          >
            Job Queue
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="/ui/#!/server/settings"
            className="glyphicons glyphicons-cogwheels"
          >
            Settings
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="#"
            className="glyphicons glyphicons-binoculars"
            onClick={handleServerInfo}
          >
            Server Info
          </a>
        </DropdownItem>
        <DropdownItem>
          <a
            href="#"
            onClick={handleDownload}
            className="glyphicons glyphicons-download-alt"
            id="download_info"
          >
            Download Server Info
          </a>
        </DropdownItem>
      </DropdownMenu>
     { visible&&<ServerInfo visible={visible} onHiding={handleServerInfo} />}
    </UncontrolledDropdown>
  )
}

export default ServerMenu
